import storage from "../helpers/storage";

export function getStoredAccessToken(): string | null {
  try {
    const token = storage.getToken();
    return token != null && token !== "" ? String(token) : null;
  } catch {
    return null;
  }
}

export function hasValidSession(): boolean {
  return !!getStoredAccessToken();
}

/** Warm lazy chunks used right after login. */
export function prefetchPostLoginChunks(): void {
  void import("../components/layout/main");
  void import("../pages/users/list");
}
